import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@vltansky/ng-select';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { BllAutocompleteComponent } from './autocomplete.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule, NgOptionHighlightModule],
  declarations: [BllAutocompleteComponent],
  exports: [BllAutocompleteComponent],
})
export class BllAutocompleteModule {}
